import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { Version } from './version'

@Mapped({
  firstVersion: { format: Version.create },
  latestVersion: { format: Version.create },
})
export class VersionSummary extends Mappable {
  firstVersion?: Version
  latestVersion?: Version

  static create<Data>(attrs: Data) {
    return new VersionSummary().map(attrs)
  }
}
